'use strict';

import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
var regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

var StringEx = function () {
    function StringEx() {
        _classCallCheck(this, StringEx);
    }

    _createClass(StringEx, null, [{
        key: 'isValidEmailFormat',
        value: function isValidEmailFormat(email) {
            return regEmail.test(email);
        }
    }]);

    return StringEx;
}();

export default StringEx;


//////////////////
// WEBPACK FOOTER
// ./submodules/dialogloop-sdk-js/dist/Utils/StringEx.js
// module id = 502
// module chunks = 0